import React from 'react';
import { Box } from '@mui/material';
import SectionTitle from '../../../../core/components/ui/SectionTitle';
import AddressAutocomplete from '../../../../core/components/ui/address/AddressAutocomplete';

interface AddressSectionProps {
  isSaving?: boolean;
}

export const AddressSection: React.FC<AddressSectionProps> = ({
  isSaving = false,
}) => {
  return (
    <Box sx={{ pt: 2, mb: 4 }}>
      <SectionTitle>Address Information</SectionTitle>
      
      <AddressAutocomplete
        disabled={isSaving}
        label="Street Address"
        required={true}
        preserveZip={true}
      />
      <input type="hidden" name="city" />
      <input type="hidden" name="state" />
      <input type="hidden" name="zip" />
    </Box>
  );
};